'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var react = _interopDefault(require('react'));

var _svg;

/**
 * Component dependencies
 */

/**
 * Component
 */


var Icon = function Icon(_ref) {
  var color = _ref.color,
      i18n = _ref.i18n;
  return _svg || (_svg = /*#__PURE__*/react.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M10 20C15.5417 20 20 15.5417 20 10C20 4.4583 15.5417 0 10 0C4.4583 0 0 4.4583 0 10C0 15.5417 4.4583 20 10 20Z",
    fill: "#BD10E0"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M5.50406 9.58001C5.50479 9.60832 5.51102 9.63523 5.52275 9.66115C5.52652 9.66984 5.52942 9.67825 5.53463 9.68624C5.55275 9.71553 5.57579 9.7423 5.60824 9.76136L5.60998 9.76192L5.61129 9.76318L9.92285 12.2066C9.92618 12.2085 9.93009 12.2075 9.93372 12.2095C9.96473 12.2249 9.99892 12.2364 10.0367 12.2364C10.0746 12.2364 10.1088 12.2249 10.1401 12.209C10.144 12.2074 10.1485 12.208 10.1522 12.206L14.3871 9.7622C14.4203 9.74314 14.4435 9.71581 14.4623 9.68596C14.4674 9.67769 14.4706 9.66998 14.4742 9.66115C14.4861 9.63509 14.4923 9.60832 14.4933 9.58001C14.4933 9.57399 14.4974 9.56908 14.497 9.56334C14.497 9.56067 14.4948 9.55885 14.4942 9.55619C14.4916 9.52409 14.4833 9.4927 14.4652 9.46327L10.2302 2.60623C10.2286 2.60343 10.2258 2.6023 10.2239 2.59964C10.2189 2.59179 10.2126 2.58563 10.2064 2.57862C10.1986 2.56979 10.1906 2.56194 10.1815 2.5541C10.1745 2.54863 10.1683 2.5426 10.1609 2.53812C10.158 2.53616 10.1566 2.53335 10.1537 2.53167C10.1487 2.52873 10.1434 2.52873 10.1385 2.52635C10.1286 2.5213 10.1188 2.51766 10.1079 2.51401C10.0989 2.51093 10.0899 2.50785 10.0802 2.50603C10.0706 2.50392 10.0614 2.5035 10.0518 2.50308C10.0466 2.50252 10.042 2.5 10.0367 2.5C10.0315 2.5 10.0275 2.50252 10.0222 2.5028C10.013 2.50364 10.0043 2.50378 9.9953 2.50561C9.98501 2.50743 9.97559 2.51065 9.96545 2.51387C9.95487 2.51738 9.94502 2.52116 9.93517 2.52621C9.93067 2.52859 9.9256 2.52859 9.92111 2.53097C9.9185 2.53251 9.91691 2.53518 9.91445 2.53672C9.90648 2.54176 9.89967 2.54793 9.89213 2.55424C9.88315 2.5618 9.87503 2.56923 9.86721 2.57806C9.86156 2.58479 9.85533 2.59081 9.85069 2.59796C9.84852 2.60076 9.84576 2.60216 9.84388 2.60497L5.53246 9.46215C5.51377 9.49158 5.50551 9.52367 5.50261 9.55633C5.50232 9.55913 5.50029 9.56095 5.5 9.5639C5.49986 9.56922 5.50377 9.57427 5.50406 9.58001Z",
    fill: "white"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M14.4403 11.3107C14.3689 11.235 14.2512 11.2201 14.1599 11.2706L9.99934 13.6465L5.84035 11.2706C5.7495 11.2195 5.63184 11.235 5.55954 11.3107C5.48752 11.387 5.47999 11.5005 5.54157 11.5847L9.81532 17.4083C9.81865 17.4128 9.82416 17.4142 9.82749 17.4183C9.83633 17.4287 9.84517 17.4378 9.85545 17.4463C9.86038 17.4502 9.86328 17.4563 9.86864 17.4598C9.87284 17.4627 9.8782 17.4615 9.88269 17.4643C9.88994 17.4683 9.89617 17.4742 9.90414 17.478C9.93283 17.4914 9.96456 17.5 9.99847 17.5H9.99948C10.0334 17.5 10.0654 17.4913 10.0942 17.478C10.1022 17.4743 10.1084 17.4685 10.1157 17.4643C10.12 17.4613 10.1254 17.4627 10.1297 17.4598C10.1351 17.4564 10.138 17.4504 10.1429 17.4463C10.1532 17.4376 10.1622 17.4287 10.1708 17.4183C10.1741 17.4142 10.1797 17.4128 10.1829 17.4083L14.4583 11.5847C14.5201 11.5005 14.5125 11.387 14.4403 11.3107Z",
    fill: "white"
  })));
};

Icon.defaultProps = {
  color: 'rgba(0, 0, 0, 0.9)'
};
/**
 * Export component
 */

var ETH20 = Icon;

module.exports = ETH20;
